module.exports = __webpack_public_path__ + "img/GORDIC-cyber-security-logo-w.svg";